<template>
  <v-chart autoresize ref="trendChart" :option="trendScatterOption" />
</template>
<script>
import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  MarkAreaComponent,
  DataZoomComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { ScatterChart } from 'echarts/charts';
use([
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  MarkAreaComponent,
  ScatterChart,
  DataZoomComponent,
]);
export default {
  name: 'BloodSugarTrendChart',
  components: {
    VChart,
  },
  props: {
    dataChart: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      trendScatterOption: {
        dataZoom: {
          start: 0,
          type: 'inside',
        },
        tooltip: {
          shared: true,
          show: true,
        },
        xAxis: {
          type: 'category',
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            symbolSize: 20,
            data: [],
            type: 'scatter',
          },
        ],
      },
    };
  },
  watch: {
    dataChart: {
      handler(val) {
        if (!val) return;
        this.generateChart();
      },
      deep: true,
    },
  },
  methods: {
    // Cập nhật qua prop option thay vì gọi clear()/setOption() trên ref:
    // vue-echarts 6.0.0-rc.3 (bản server cài theo yarn.lock) không expose các method này
    generateChart() {
      let scatterChart = this.dataChart.trendItems.items
        .map((el) => {
          return el.subTrends.map((e) => ({
            name: e.type,
            value: [
              this.$moment(el.date * 1000).format('DD/MM/YYYY'),
              e.glucose,
            ],
            timeFrame: e.timeFrameName,
            itemStyle: {
              color: e.color,
            },
          }));
        })
        .reduce((a, b) => a.concat(b), []);

      this.scatterChartSeries = scatterChart;
      // Gán object mới để vue-echarts chắc chắn nhận ra thay đổi
      this.trendScatterOption = {
        ...this.trendScatterOption,
        series: [{ ...this.trendScatterOption.series[0], data: scatterChart }],
      };
    },
  },
};
</script>
<style lang=""></style>
